<template>
  <div class="laypanel" style="margin-top: 10px;">
    <el-tabs v-model="saletab" type="card" style="height: 200px; margin-left: 40px; margin-right:40px;">
      <el-tab-pane label="促销方式管理" name="cxway">
        <el-table
          stripe
          :header-cell-style="{'text-align':'center'}"
          :data="cxwaydata"
          ref="pcusertb">
          <el-table-column
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="promotion_type"
            label="分类">
          </el-table-column>
          <el-table-column
            prop="pdes"
            label="描述">
          </el-table-column>
          <el-table-column
            label="操作"
            min-width="50px"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="删除分类">
                <i class="fa fa-trash-o fa-lg curpointer" v-on:click="deltype(scope.row)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="促销规则" name="cxgz">
        <el-tabs tab-position="right" v-model="cxtypeinfo" accordion @change="cxtypechange">
          <el-tab-pane label="满减">
            <div>
              <el-row class="querypanel">
                <el-col :span="12">
                  <el-form   label-width="120px" label-position="left">
                    <el-form-item label="满额(元):" >
                      <el-input v-model="maneprice" placeholder="请输入满额金额"></el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="12">
                  <el-form   label-width="120px" label-position="left">
                    <el-form-item label="减额(元):" style="margin-left: 20px;">
                      <el-input v-model="manjprice" placeholder="请输入减额金额"></el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="24">
                  <div>
                    <el-button style="margin-top: 10px; margin-left: 10px;" @click="addmjgz">添加满减规则</el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row class="querypanel">
                <el-col :span="24">
                  <el-table
                    stripe
                    :header-cell-style="{'text-align':'center'}"
                    :data="mjcxdata"
                    ref="multipleTable">
                    <el-table-column
                      min-width="30px"
                      prop="id"
                      label="规则编号"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="full_price"
                      label="满额金额">
                    </el-table-column>
                    <el-table-column
                      prop="minus_price"
                      label="减额金额">
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      width="80px"
                    >
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="移除该规则" placement="top-start">
                          <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="removemjgz(scope.$index, mjcxdata)"></i>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="满赠">
            <div>
              <el-row class="querypanel">
                <el-col :span="12">
                  <el-form   label-width="120px" label-position="left">
                    <el-form-item label="请输入商品名称" >
                      <el-input v-model="qgoodsname" placeholder="请输入内容">
                        <el-button @click="querygoods" slot="append" icon="el-icon-search"></el-button>
                      </el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="24">
                  <el-form   label-width="120px" label-position="left">
                    <el-form-item label="赠品选择:" >
                      <el-table
                        stripe
                        :header-cell-style="{'text-align':'center'}"
                        :data="goodsdata"
                        ref="zengpintb">
                        <el-table-column
                          type="selection"
                          width="55">
                        </el-table-column>
                        <el-table-column
                          prop="name"
                          label="商品名称">
                        </el-table-column>
                        <el-table-column
                          prop="barcode"
                          label="客户条码">
                        </el-table-column>
                      </el-table>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="12">
                  <el-form   label-width="120px" label-position="left">
                    <el-form-item label="满额(元):" >
                      <el-input v-model="mzpricecount" placeholder="请输入满额金额"></el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="12">
                  <el-form   label-width="120px" label-position="left">
                    <el-form-item label="赠品数量:" style="margin-left: 20px;">
                      <el-input v-model="mzcount" placeholder="请输入赠品数量"></el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="24">
                  <div>
                    <el-button style="margin-top: 10px; margin-left: 10px;" @click="addmzgz">添加满赠规则</el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row class="querypanel">
                <el-col :span="24">
                  <el-table
                    stripe
                    :header-cell-style="{'text-align':'center'}"
                    :data="cxmzdata"
                    ref="multipleTable">
                    <el-table-column
                      min-width="30px"
                      prop="id"
                      label="规则编号"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="full_price"
                      label="满额金额">
                    </el-table-column>
                    <el-table-column
                      prop="name"
                      label="赠品名称">
                    </el-table-column>
                    <el-table-column
                      prop="count"
                      label="赠品数量">
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      width="80px"
                    >
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="移除该规则" placement="top-start">
                          <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="removecxmz(scope.$index, cxmzdata)"></i>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="限时促销">
            <div>
              <el-row class="querypanel">
                <el-col :span="12">
                  <el-form   label-width="120px" label-position="left">
                    <el-form-item label="限减金额:" >
                      <el-input v-model="xsxjje" placeholder="请输入限减金额"></el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="24">
                  <div>
                    <el-button style="margin-top: 10px; margin-left: 10px;" @click="addxscz">添加限时促销规则</el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row class="querypanel">
                <el-col :span="24">
                  <el-table
                    stripe
                    :header-cell-style="{'text-align':'center'}"
                    :data="xscxdata"
                    ref="multipleTable">
                    <el-table-column
                      min-width="30px"
                      prop="id"
                      label="规则编号"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="cxrange"
                      label="限减金额">
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      width="80px"
                    >
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="移除该规则" placement="top-start">
                          <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="removexscx(scope.$index, xscxdata)"></i>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="限期打折">
            <div>
              <el-row class="querypanel">
                <el-col :span="12">
                  <el-form   label-width="120px" label-position="left">
                    <el-form-item label="限时折扣百分比:" >
                      <el-input v-model="xsxjpercent" placeholder="请输入限时折扣百分比"></el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="24">
                  <div>
                    <el-button style="margin-top: 10px; margin-left: 10px;" @click="addxszk">添加限时折扣规则</el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row class="querypanel">
                <el-col :span="24">
                  <el-table
                    stripe
                    :header-cell-style="{'text-align':'center'}"
                    :data="xszkdata"
                    ref="multipleTable">
                    <el-table-column
                      min-width="30px"
                      prop="id"
                      label="规则编号"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="cxpercent"
                      label="限时折扣">
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      width="80px"
                    >
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="移除该规则" placement="top-start">
                          <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="removexszk(scope.$index, xszkdata)"></i>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import Vue from 'vue'
  import axios from 'axios'
  import '../../../static/css/my.css'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'SaleControl',
    data () {
      return {
        cxwaydata: [],
        cxmzdata: [],
        mjcxdata: [],
        cxtypeinfo: '',
        maneprice: '',
        manjprice: '',
        mzpricecount: '',
        qgoodsname: '',
        mzcount: '',
        saletab: 'cxgz',
        taskdate: '',
        taskdes: '',
        taskname: '',
        taskdata: [],
        goodstypelist: '',
        goodstype: '',
        goodsdata: [],
        xscxdata: [],
        xszkdata: [],
        xsxjje: '',
        xsxjpercent: '',
        khid: '',
        cxactive: '',
        selectcxmain: '',
        subtaskdata: []
      }
    },
    mounted: function () {
      that = this
      console.log(that)
      var v = getCookie('cusid')
      this.khid = v
      that = this
      that.quercxway()
      that.querymj()
      that.querygoodstype()
      that.querycxmz()
      that.queryxscx()
      that.queryxsdz()
    },
    methods: {
      querymj () {
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('phone') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryptfm',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log('满减',res.data)
            if (res.data.length > 0) {
              that.mjcxdata = res.data
            } else {
              that.mjcxdata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      deltype (row) {
        window.console.log(row)
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cndelpttype',
          method: 'post',
          data: {
            id: row.id.toString()
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.quercxway()
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      addmjgz () {
        var addgz = {
          id: '',
          typeid: that.cxwaydata[parseInt(that.cxtypeinfo)].id.toString(),
          full_price: this.maneprice,
          minus_price: this.manjprice,
          ownphone: localStorage.getItem('phone'),
          cusid: that.khid.toString()
        }
        console.log(addgz)
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addptfm',
          method: 'post',
          data: addgz,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '添加成功!'
              })
              that.querymj()
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      addmzgz () {
        console.log(this.$refs.zengpintb)
        var indata = {
          id: '',
          typeid: that.cxwaydata[parseInt(that.cxtypeinfo)].id.toString(),
          full_price: that.mzpricecount,
          goods_id: this.$refs.zengpintb.selection[0].id.toString(),
          count: that.mzcount.toString(),
          ownphone: localStorage.getItem('phone'),
          cusid: that.khid.toString()
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addptgw',
          method: 'post',
          data: indata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '添加规则成功'
              })
              that.$options.methods.querycxmz()
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      addxscz () {
        var indata = {
          id: '',
          typeid: that.cxwaydata[parseInt(that.cxtypeinfo)].id.toString(),
          cxrange: that.xsxjje,
          ownphone: localStorage.getItem('phone'),
          cusid: that.khid.toString()
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addptsd',
          method: 'post',
          data: indata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '添加规则成功'
              })
              that.$options.methods.queryxscx()
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      addxszk () {
        var indata = {
          id: '',
          typeid: that.cxwaydata[parseInt(that.cxtypeinfo)].id.toString(),
          cxpercent: that.xsxjpercent,
          ownphone: localStorage.getItem('phone'),
          cusid: that.khid.toString()
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addptdiscount',
          method: 'post',
          data: indata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '添加规则成功'
              })
              that.queryxsdz()
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      removemjgz (index, data) {
        var selectdata = data[index]
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cndelptfm',
          method: 'post',
          data: {
            id: selectdata.id.toString()
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.querymj()
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      removecxmz (index, data) {
        var selectdata = data[index]
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cndelptgw',
          method: 'post',
          data: {
            id: selectdata.id.toString()
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.querycxmz()
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      removexscx (index, data) {
        var selectdata = data[index]
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cndelptsd',
          method: 'post',
          data: {
            id: selectdata.id.toString()
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.queryxscx()
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      removexszk (index, data) {
        var selectdata = data[index]
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cndelptdiscount',
          method: 'post',
          data: {
            id: selectdata.id.toString()
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.queryxsdz()
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      querycxmz () {
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('phone') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryptgw',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log('*****************初始化满赠数据******************')
            window.console.log(res.data)
            if (res.data.length > 0) {
              that.cxmzdata = res.data
            } else {
              that.cxmzdata = []
              console.log('获取满赠数据失败')
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      querygoodstype () {
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('phone') + "' and goods_type_id = '" + that.goodstype,
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/quergtype',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log('*****************初始化分类数据******************')
            if (res.data.length > 0) {
              that.goodstypelist = JSON.parse(res.data[0].typetree)
            } else {
              that.goodstypelist = []
              var adata = {
                id: 0,
                name: '默认类别',
                imgurl: '',
                children: []
              }
              that.goodstypelist.push(adata)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      querygoods () {
        console.log('选择商品类别')
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('phone') + "' and name like  '%" + that.qgoodsname + "%'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryginfo',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log('*****************初始化分类数据******************')
            if (res.data.length > 0) {
              console.log('已完成分类数据初始化')
              that.goodsdata = res.data
            } else {
              that.goodsdata = []
              console.log('获取分类数据失败')
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      queryxscx () {
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('phone') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryptsd',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.xscxdata = res.data
            } else {
              that.xscxdata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      queryxsdz () {
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('phone') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryptdiscount',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.xszkdata = res.data
            } else {
              that.xszkdata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      quercxway () {
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('phone') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querypttype',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log('促销方式',res.data)
            if (res.data.length > 0) {
              window.console.log('OK')
              that.cxwaydata = res.data
            } else {
              that.cxwaydata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      cxtypechange (val) {
        that.cxtypeinfo = val
      }

    }
  }
  function getCookie (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }
</script>



// WEBPACK FOOTER //
// src/components/control/SaleControl.vue